import { Action } from '@ngrx/store';
import { IPaymentCreditFormCC, IPaymentCreditFormExt } from 'src/commons';

export enum PaymentCreditActionTypes {

  LoadPaymentCreditInitState = '[PaymentCredit] Load PaymentCredit Initial State',

  LoadPaymentCreditFormCCState = '[PaymentCredit] Load PaymentCredit FormCC State',
  LoadPaymentCreditFormCCStateSuccess = '[PaymentCredit] Load PaymentCredit FormCC State Success',
  LoadProcessedPaymentCreditFormCCState = '[PaymentCredit] Load Processed PaymentCredit FormCC State',
  LoadProcessedPaymentCreditFormCCStateSuccess = '[PaymentCredit] Load Processed PaymentCredit FormCC State Success',

  LoadPaymentCreditFormCGState = '[PaymentCredit] Load PaymentCredit FormCG State',
  LoadPaymentCreditFormCGStateSuccess = '[PaymentCredit] Load Payment Credit FormCG State Success',
  LoadProcessedPaymentCreditFormCGState = '[PaymentCredit] Load Processed Payment Credit FormCG State',
  LoadProcessedPaymentCreditFormCGStateSuccess = '[PaymentCredit] Load Processed PaymentCredit FormCG State Success',

  LoadPaymentCreditFormPPState = '[PaymentCredit] Load PaymentCredit FormPP State',
  LoadPaymentCreditFormPPStateSuccess = '[PaymentCredit] Load PaymentCredit FormPP State Success',
  LoadProcessedPaymentCreditFormPPState = '[PaymentCredit] Load Processed Payment Credit FormPP State',
  LoadProcessedPaymentCreditFormPPStateSuccess = '[PaymentCredit] Load Processed PaymentCredit FormPP State Success',

  LoadPaymentCreditFormESState = '[PaymentCredit] Load PaymentCredit FormES State',
  LoadPaymentCreditFormESStateSuccess = '[PaymentCredit] Load Payment Credit FormES State Success',
  LoadProcessedPaymentCreditFormESState = '[PaymentCredit] Load Processed Payment Credit FormES State',
  LoadProcessedPaymentCreditFormESStateSuccess = '[PaymentCredit] Load Processed PaymentCredit FormES State Success',

  ProcessFormCCAsCredit = '[PaymentCredit] Process FormCC As Credit Payment',
  ProcessFormExtAsCredit = '[PaymentCredit] Process External Form As Credit Payment',

  LoadPaymentCreditStateFail = '[PaymentCredit] Load PaymentCredit State Fail',
  PaymentCreditScreenErrorReset = '[PaymentCredit] PaymentCredit Screen Error Reset'

  // LoadPaymentCreditFormCIState = '[PaymentCredit] Load PaymentCredit FormCI State',
  // LoadPaymentCreditFormCIStateSuccess = '[PaymentCredit] Load Payment Credit FormCI State Success',
  // LoadProcessedPaymentCreditFormCIState = '[PaymentCredit] Load Processed Payment Credit FormCI State',
  // LoadProcessedPaymentCreditFormCIStateSuccess = '[PaymentCredit] Load Processed PaymentCredit FormCI State Success',

}

export class LoadPaymentCreditInitState implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditInitState;
}

export class LoadPaymentCreditFormCCState implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormCCState;
}

export class LoadPaymentCreditFormCCStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormCCStateSuccess;
  constructor(public payload: IPaymentCreditFormCC) { }
}

export class LoadProcessedPaymentCreditFormCCState implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCCState;
}

export class LoadProcessedPaymentCreditFormCCStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCCStateSuccess;
  constructor(public payload: IPaymentCreditFormCC) { }
}

export class LoadPaymentCreditFormCGState implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormCGState;
}

export class LoadPaymentCreditFormCGStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormCGStateSuccess;
  constructor(public payload: IPaymentCreditFormExt) { }
}

export class LoadProcessedPaymentCreditFormCGState implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCGState;
}

export class LoadProcessedPaymentCreditFormCGStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCGStateSuccess;
  constructor(public payload: IPaymentCreditFormExt) { }
}

export class LoadPaymentCreditFormPPState implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormPPState;
}

export class LoadPaymentCreditFormPPStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormPPStateSuccess;
  constructor(public payload: IPaymentCreditFormExt) { }
}

export class LoadProcessedPaymentCreditFormPPState implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormPPState;
}

export class LoadProcessedPaymentCreditFormPPStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormPPStateSuccess;
  constructor(public payload: IPaymentCreditFormExt) { }
}

export class LoadPaymentCreditFormESState implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormESState;
}

export class LoadPaymentCreditFormESStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormESStateSuccess;
  constructor(public payload: IPaymentCreditFormExt) { }
}

export class LoadProcessedPaymentCreditFormESState implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormESState;
}

export class LoadProcessedPaymentCreditFormESStateSuccess implements Action {
  readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormESStateSuccess;
  constructor(public payload: IPaymentCreditFormExt) { }
}

export class ProcessFormCCAsCredit implements Action {
  readonly type = PaymentCreditActionTypes.ProcessFormCCAsCredit;
  constructor(public payload: any) { }
}

export class ProcessFormExtAsCredit implements Action {
  readonly type = PaymentCreditActionTypes.ProcessFormExtAsCredit;
  constructor(public payload: any) { }
}

export class LoadPaymentCreditStateFail implements Action {
  readonly type = PaymentCreditActionTypes.LoadPaymentCreditStateFail;
  constructor(public payload: any) { }
}

export class PaymentCreditScreenErrorReset implements Action {
  readonly type = PaymentCreditActionTypes.PaymentCreditScreenErrorReset;
}

export type PaymentCreditActions =
  LoadPaymentCreditInitState

  | LoadPaymentCreditFormCCState
  | LoadPaymentCreditFormCCStateSuccess
  | LoadProcessedPaymentCreditFormCCState
  | LoadProcessedPaymentCreditFormCCStateSuccess

  | LoadPaymentCreditFormCGState
  | LoadPaymentCreditFormCGStateSuccess
  | LoadProcessedPaymentCreditFormCGState
  | LoadProcessedPaymentCreditFormCGStateSuccess

  | LoadPaymentCreditFormPPState
  | LoadPaymentCreditFormPPStateSuccess
  | LoadProcessedPaymentCreditFormPPState
  | LoadProcessedPaymentCreditFormPPStateSuccess

  | LoadPaymentCreditFormESState
  | LoadPaymentCreditFormESStateSuccess
  | LoadProcessedPaymentCreditFormESState
  | LoadProcessedPaymentCreditFormESStateSuccess

  | ProcessFormCCAsCredit
  | ProcessFormExtAsCredit

  | LoadPaymentCreditStateFail
  | PaymentCreditScreenErrorReset;



// | LoadPaymentCreditFormCIState
// | LoadPaymentCreditFormCIStateSuccess
// | LoadProcessedPaymentCreditFormCIState
// | LoadProcessedPaymentCreditFormCIStateSuccess



// export class LoadPaymentCreditFormCIState implements Action {
//   readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormCIState;
// }

// export class LoadPaymentCreditFormCIStateSuccess implements Action {
//   readonly type = PaymentCreditActionTypes.LoadPaymentCreditFormCIStateSuccess;
//   constructor(public payload: IPaymentCreditFormExt) { }
// }
// export class LoadProcessedPaymentCreditFormCIState implements Action {
//   readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCIState;
// }

// export class LoadProcessedPaymentCreditFormCIStateSuccess implements Action {
//   readonly type = PaymentCreditActionTypes.LoadProcessedPaymentCreditFormCIStateSuccess;
//   constructor(public payload: IPaymentCreditFormExt) { }
// }